import router from '@/router'

export function redirectToLogin() {
  const currentRoute = router.currentRoute

  if (currentRoute.name === 'Login') {
    return Promise.resolve()
  }

  return router.push({
    path: '/login',
    query: { redirect: currentRoute.fullPath }
  })
}
